/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { registerField } from 'core/forms';

import filter from 'lodash/filter';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';

import FormFieldSelectItems from '../components/formFieldSelectItems';

const FormFieldSelectItemsContainer = createReactClass({
  propTypes: {
    fieldId: PropTypes.string.isRequired,
    schema: PropTypes.shape({
      handleLoadOptions: PropTypes.func,
      selectProps: PropTypes.objectOf(PropTypes.any),
      isReadOnly: PropTypes.bool,
    }).isRequired,
    updateField: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  },

  getInitialState() {
    return {
      selectedOptions: this.props.value,
    };
  },

  componentDidUpdate() {
    const { selectedOptions } = this.state;
    const { value } = this.props;
    if (!isEqual(value, selectedOptions)) this.setState({ selectedOptions: value });
  },

  handleAddSelected(option) {
    const { selectedOptions } = this.state;
    const transformedOption = { id: option.id, name: option.value.name };
    const updatedOptions = [...selectedOptions, transformedOption];

    this.setState({ selectedOptions: updatedOptions });

    this.props.updateField(updatedOptions);
  },

  handleFilterOption({ data }) {
    const { selectedOptions } = this.state;
    const { id } = data;
    return !find(selectedOptions, (selectedOption) => selectedOption.id === id);
  },

  handleRemoveSelected(optionId) {
    const { selectedOptions } = this.state;
    const updatedOptions = filter(selectedOptions, (selectedOption) => selectedOption.id !== optionId);

    this.setState({ selectedOptions: updatedOptions });

    this.props.updateField(updatedOptions);
  },

  async handleOnLoadOptions() {
    const { handleLoadOptions } = this.props.schema;
    const { selectedOptions } = this.state;
    const selectedOptionIds = selectedOptions.map((selectedOption) => selectedOption.id);

    const loadedOptions = await handleLoadOptions('');

    return filter(loadedOptions, (option) => !selectedOptionIds.includes(option.id));
  },

  render() {
    const { schema, fieldId } = this.props;
    const { selectedOptions } = this.state;

    const { selectProps, isReadOnly } = schema;

    return (
      <FormFieldSelectItems
        fieldId={fieldId}
        handleAddSelected={this.handleAddSelected}
        handleFilterOption={this.handleFilterOption}
        handleOnLoadOptions={this.handleOnLoadOptions}
        handleRemoveSelected={this.handleRemoveSelected}
        selectedOptions={selectedOptions}
        selectProps={selectProps}
        isReadOnly={isReadOnly}
      />
    );
  },
});

registerField('SelectItems', React.memo(FormFieldSelectItemsContainer));

export default FormFieldSelectItemsContainer;
